module.exports = __webpack_public_path__ + "static/social-108c821bbb272e803a4d21a581e5ca0c.png";